import { makeStyles } from '@mui/styles';

export default makeStyles(() =>
  ({
    space: {
      display: 'flex',
      flex: 1
    }
  }),
);
